import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import { Button, Press } from '@dorixona/ui'
import { BackButton } from '../../ui/BackButton'
import { Icon } from '../../ui/Icon'
import { LoginCta } from '../../ui/LoginCta'
import { Failed, Loading } from '../../ui/Load'
import { useSession } from '../../app/session'
import { useAddresses, type Address } from './api'

/**
 * «Мои адреса» (F-33): сохранённые адреса доставки, основной — первым.
 * Адрес с доставки сервер запоминает сам, здесь их добавляют заранее, дают
 * имена («Дом», «Работа»), выбирают основной и удаляют. Нажатие на строку
 * открывает адрес на правку.
 */
export function AddressesScreen() {
  const navigate = useNavigate()
  const { t } = useTranslation(['account', 'common'])
  const { isAuthenticated } = useSession()
  const addresses = useAddresses(isAuthenticated)
  const list = addresses.data ?? []

  return (
    <section className="screen cart-wrap">
      <div className="mhead">
        <BackButton to="/profile" />
        <h1>{t('account:addresses.title')}</h1>
      </div>

      {!isAuthenticated ? (
        <LoginCta
          onSignIn={() => {
            void navigate('/login')
          }}
        />
      ) : addresses.isPending ? (
        <Loading what={t('common:state.loading')} count={2} />
      ) : addresses.isError ? (
        <Failed
          error={addresses.error}
          onRetry={() => {
            void addresses.refetch()
          }}
        />
      ) : (
        <>
          {list.length === 0 ? (
            <div className="card empty">
              <Icon name="i-pin" size={54} />
              <div className="t">{t('account:addresses.emptyTitle')}</div>
              {t('account:addresses.empty')}
            </div>
          ) : (
            <ul className="acc-card addr-list">
              {list.map((address) => (
                <li key={address.id}>
                  <AddressRow
                    address={address}
                    onPress={() => {
                      void navigate(`/profile/addresses/${address.id}`)
                    }}
                  />
                </li>
              ))}
            </ul>
          )}
          <Button
            className="acc-add"
            onPress={() => {
              void navigate('/profile/addresses/new')
            }}
          >
            {t('account:addresses.add')}
          </Button>
        </>
      )}
    </section>
  )
}

function AddressRow({ address, onPress }: { address: Address; onPress: () => void }) {
  const { t } = useTranslation('account')
  return (
    <Press squish="row" className="addr-item" onPress={onPress}>
      <Icon name="i-pin" size={19} />
      <span className="addr-item__text">
        <span className="t1">{address.tag || address.label}</span>
        {address.tag ? <span className="t2">{address.label}</span> : null}
      </span>
      {address.def ? <span className="addr-item__def">{t('addresses.default')}</span> : null}
      <Icon name="i-chev" size={16} />
    </Press>
  )
}
